import React, { useEffect, useState } from 'react'
import './Navbar.css'
import { useSelector, useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { Button } from '@material-ui/core'
import { NavLink } from 'react-router-dom'
import Popup from './Popup'
import Login from '../Account/Login'
import Register from '../Account/Register'
import { useHistory } from 'react-router-dom'
import LoginRetailer from './Retailer/LoginRetailer'
import { selectIsUserLoggedIn } from '../DataStore/Slices/userSlice'
import CheckUserProvider from '../AllHooks/CheckUserProvider'
import LocationCityIcon from '@material-ui/icons/PinDrop'
import CloseIcon from '@material-ui/icons/Close'
import { sleep } from './Models/CommonFunc'
import { pushCityInfo, selectCityName, popCityInfo } from '../DataStore/Slices/citySlice';
import { pushIsAppLoading } from '../DataStore/Slices/appSlice';

function Navbar() {
  const [openPopup, setOpenPopup] = useState(false)
  const [openRegisterPopup, setOpenRegisterPopup] = useState(false)
  const [openEmpLogin, setOpenEmpLogin] = useState(false)
  const { userData } = CheckUserProvider()
  const history = useHistory()
  const dispatch = useDispatch();
  const [profileMenuOption, setProfileMenuOption] = useState(null)
  const isUserLoggedIn = useSelector(selectIsUserLoggedIn)
  const [width, setWidth] = useState(window.innerWidth)
  const [isHandleCity, setIsHandleCity] = useState(false)
  const [selectedCity, setSelectedCity] = useState('')
  const [pincode, setPincode] = useState('')

  useEffect(() => {
    fetchCityInfo();
  }, [selectedCity,pincode]);

  const fetchCityInfo = () => {
    const city = localStorage.getItem('city') ?? '';
    const pincode = localStorage.getItem('pincode') ?? '';
    setSelectedCity(city);
    setPincode(pincode);
    dispatch(pushCityInfo({
      city: city,
      pincode: pincode
    }));
  }
  

  const handleWindowSizeChange = () => {
    setWidth(window.innerWidth)
  }
  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange)
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange)
    }
  }, [])

  const isMobile = width <= 768

  const profileMenuClose = (tag) => {
    if (tag === 'register') {
      history.push('/activity/Register')
    } else if (tag === 'login') {
      setOpenEmpLogin(true)
    }
    setProfileMenuOption(null)
  }

  useEffect(() => {
    if (isUserLoggedIn) {
      setOpenPopup(true)
    }
  }, [isUserLoggedIn])

  useEffect(async () => {
    await sleep(2000)
    setOpenPopup(false)
    setOpenRegisterPopup(false)
  }, [userData])

  useEffect(() => {
    // document.body.style.overflow = 'hidden';
    return () => (document.body.style.overflow = 'scroll')
  }, [])

  const handleCityMenu = () => {
    setIsHandleCity(!isHandleCity)
    fetchCityInfo();
  }

  const handleSelectCity = (city) => {
    setSelectedCity(city)
    dispatch(pushCityInfo({
      city: city
    }));
    dispatch(pushIsAppLoading({
      loading: true
    }));
    localStorage.setItem('city', city);
    setPincode('');
    setIsHandleCity(!isHandleCity)
    // window.location.reload(true)
    history.push("/home")
  }

  const resetCity = () => {
    dispatch(pushCityInfo({
      city: '',
      pincode: ''
    }));
    dispatch(pushIsAppLoading({
      loading: true
    }));
    localStorage.setItem('city', '');
    localStorage.setItem('pincode', '');
    setSelectedCity('');
    setPincode('');
    setIsHandleCity(!isHandleCity)
    // window.location.reload(true)
    history.push("/home")
  }

  const onPincodeEnter = async (data) => {
    setPincode(data.pincode);
    dispatch(pushCityInfo({
      pincode: data.pincode
    }));
    dispatch(pushIsAppLoading({
      loading: true
    }));
    localStorage.setItem('pincode', data.pincode);
    setIsHandleCity(!isHandleCity)
    history.push("/home")
  }

  return (
    <div className="container-fluid header">
      <div className="row">
        <div className="col-lg-10 col-md-10 col-sm-12 mx-auto">
          <nav className="navbar navbar-expand-lg navbar-light">
            <div className="container-fluid Something">
              <NavLink className="" to="/">
                <img
                  className="img-fluid logoStyle"
                  src="/assets/Logo.webp"
                  alt="Website Logo"
                />
              </NavLink>
              <button
                className="navbar-toggler"
                type="button"
                id="collapse-button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
              <div
                className="collapse navbar-collapse"
                id="navbarSupportedContent"
              >
                <ul className="navbar-nav me-auto mb-2 mb-lg-0 mt-1">
                  <li className="nav-item">
                    <NavLink
                      className="nav-link"
                      to="/"
                      onClick={() => {
                        isMobile &&
                          document.getElementById('collapse-button').click()
                      }}
                    >
                      <span className="navbar__navlinks">Home</span>
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      className="nav-link"
                      to="/about"
                      onClick={() => {
                        isMobile &&
                          document.getElementById('collapse-button').click()
                      }}
                    >
                      <span className="navbar__navlinks">About Us</span>
                    </NavLink>
                  </li>
                  {/* <li className="nav-item">
                    <NavLink
                      className="nav-link"
                      to="/events"
                      onClick={() => {
                        isMobile &&
                          document.getElementById('collapse-button').click()
                      }}
                    >
                      <span className="navbar__navlinks">Events</span>
                    </NavLink>
                  </li> */}
                  <li className="nav-item">
                    <NavLink
                      className="nav-link"
                      to="/contact"
                      onClick={() => {
                        isMobile &&
                          document.getElementById('collapse-button').click()
                      }}
                    >
                      <span className="navbar__navlinks">Contact Us</span>
                    </NavLink>
                  </li>
                </ul>
                <div className="d-flex justify-content-center align-items-center">
                  <div className="d-flex justify-content-center align-items-center">
                    <div className="navbar__account">
                      <Button
                        variant="contained"
                        color="primary"
                        className="navbar__btnLogin"
                        size="small"
                        onClick={() => history.push('/activity/Login')}
                      >
                        Business Login
                      </Button>
                    </div>
                    <div className="navbar__account">
                      <Button
                        variant="contained"
                        color="primary"
                        className="navbar__btnLogin"
                        size="small"
                        onClick={() => handleCityMenu()}
                      >
                        {selectedCity} {' '}<LocationCityIcon />
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </nav>
          <Popup
            openPopup={openPopup}
            setOpenPopup={setOpenPopup}
            title="Login"
          >
            <Login />
          </Popup>
          <Popup
            openPopup={openRegisterPopup}
            setOpenPopup={setOpenRegisterPopup}
            title="Register"
          >
            <Register />
          </Popup>
          <Popup
            openPopup={openEmpLogin}
            setOpenPopup={setOpenEmpLogin}
            title="Chemist Store Sign In"
          >
            <LoginRetailer isCaptchaVisible={true} />
          </Popup>

          {isHandleCity && (
            <div className="citySelection citySelect">
              <div className="city-selection fixed top-0">
                <div className="city-selection-body mt-2.5 md:mt-[100px]">
                  <div className="relative p-3.5">
                    <div className="row__close">
                      <p className="text-sm sm:text-lg leading-6 font-semibold text-ruby-alpha text-left ">
                        Select your city
                      </p>
                      <button onClick={() => handleCityMenu()}>
                        <CloseIcon />
                      </button>
                    </div>
                    <div className="city-menu w-full flex flex-wrap justify-center mt-5">
                      <div className="ciy-menu-cards p-4 text-center mx-2 shadow-smm ">
                        <ul>
                          <li>
                            <input
                              type="radio"
                              id="myCheckbox1"
                              name="selectedCity"
                              checked={selectedCity == "Delhi" ? true : false}
                              onChange={() => handleSelectCity('Delhi')}
                            />
                            <label htmlFor="myCheckbox1">
                              <img
                                className="inline-block w-12.5 h-12.5 bg-no-repeat bg-contain banglore"
                                src="https://d3juy0zp6vqec8.cloudfront.net/images/icons/delhi.svg"
                              ></img>
                              <p className="text-xs leading-4 text-center font-normal text-ruby-alpha">
                                Delhi
                              </p>
                            </label>
                          </li>
                          <li>
                            <input
                              type="radio"
                              id="myCheckbox2"
                              name="selectedCity"
                              checked={selectedCity == "Patna" ? true : false}
                              onChange={() => handleSelectCity('Patna')}
                            />
                            <label htmlFor="myCheckbox2">
                              <img
                                className="inline-block w-12.5 h-12.5 bg-no-repeat bg-contain banglore"
                                src="https://d3juy0zp6vqec8.cloudfront.net/images/icons/bangalore.svg"
                              ></img>
                              <p className="text-xs leading-4 text-center font-normal text-ruby-alpha">
                                Patna
                              </p>
                            </label>
                          </li>
                          <li>
                            <input
                              type="radio"
                              id="myCheckbox3"
                              name="selectedCity"
                              checked={selectedCity == "Motihari" ? true : false}
                              onChange={() => handleSelectCity('Motihari')}
                            />
                            <label htmlFor="myCheckbox3">
                              <img
                                className="inline-block w-12.5 h-12.5 bg-no-repeat bg-contain banglore"
                                src="https://d3juy0zp6vqec8.cloudfront.net/images/icons/gurgaon.svg"
                              ></img>
                              <p className="text-xs leading-4 text-center font-normal text-ruby-alpha">
                                Motihari
                              </p>
                            </label>
                          </li>
                          <li>
                            <input
                              type="radio"
                              id="myCheckbox4"
                              name="selectedCity"
                              checked={selectedCity == "Bhagalpur" ? true : false}
                              onChange={() => handleSelectCity('Bhagalpur')}
                            />
                            <label htmlFor="myCheckbox4">
                              <img
                                className="inline-block w-12.5 h-12.5 bg-no-repeat bg-contain banglore"
                                src="https://d3juy0zp6vqec8.cloudfront.net/images/icons/mumbai.svg"
                              ></img>
                              <p className="text-xs leading-4 text-center font-normal text-ruby-alpha">
                                Bhagalpur
                              </p>
                            </label>
                          </li>
                          <li>
                            <input
                              type="radio"
                              id="myCheckbox5"
                              name="selectedCity"
                              checked={selectedCity == "" ? true : false}
                              onChange={() => resetCity()}
                            />
                            <label htmlFor="myCheckbox5">
                              <img
                                className="inline-block w-12.5 h-12.5 bg-no-repeat bg-contain india"
                                src="https://png.pngtree.com/png-clipart/20200701/original/pngtree-city-silhouette-high-rise-buildings-png-image_5408068.jpg"
                              ></img>
                              <p className="text-xs leading-4 text-center font-normal text-ruby-alpha india-text-ruby-alpha">
                                All
                              </p>
                            </label>
                          </li>
                        </ul>
                        <div>
                        {/* {selectedCity != "" && <div className="mt-5 text-left">
                          <p className="text-xs leading-4 text-center font-normal text-ruby-alpha">
                            Enter Pincode for Acurate Result:
                          </p>
                          <div className="d-flex justify-content-center w-100 align-items-center homeScreen__searchBox mt-2">
                            <input 
                              type="number" 
                              placeholder="Enter Pincode" 
                              className="border-0"
                              defaultValue={pincode ? pincode : ''}
                              name="pincode" ref={register} />
                              <div className="d-flex btn__action">
                                <Button type="button" variant="contained" color="primary" className="navbar__btnSearch" size="small"
                                    onClick={handleSubmit(onPincodeEnter)}>
                                  <SendIcon className="mr-2" fontSize="small" />
                                </Button>
                              </div>
                          </div>
                        </div>} */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Navbar
